import { Link, Outlet, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { GetSingleWorkoutSecuredAsync, selectEditFlag, selectSingleWorkout, setEditFlag, setShowManagerNotesModal, UpdateParticipantInfoAsync } from '../features/add_workout/workoutSlice';
import { useEffect, useState } from 'react';
import { changeDateFormat, participant, tableDesign } from '../app/consts';
import { Button, Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import { createExcel } from './exportExcel';
import { useConfirm } from './AlertDialogModal';


const ManageWorkoutParticipants = () => {
    const WorkoutId = useParams().workoutId;
    const dispatch = useAppDispatch();
    const editFlag = useAppSelector(selectEditFlag);
    const currentWorkout = useAppSelector(selectSingleWorkout)
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(15);
    const [SelectVisibility, setSelectVisibility] = useState<"active" | "inactive" | "all">("active");

    const confirm = useConfirm();

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleUpdateParticipant = async (updated_participant: participant, field: string) => {
        let title = ""
        let content = ""

        const handleConfirmation = async (title: string, content: string) => {
            const isConfirmed = await confirm({
                title: title,
                content: content,
            });
            return isConfirmed
        }

        switch (field) {
            case "isPaid":
                title = "שינוי סטטוס תשלום"
                content = `האם לעדכן את סטטוס התשלום של ${updated_participant.firstName} ${updated_participant.lastName}`
                content += updated_participant.isPaid ? ` ל- "שולם"?` : ` ל- "לא שולם"?`
                if (! await (handleConfirmation(title, content))) {
                    return
                }

                break;


            case "isActive":
                title = "שינוי סטטוס הרשמה"
                content = `האם לעדכן את סטטוס ההרשמה של ${updated_participant.firstName} ${updated_participant.lastName}`
                content += updated_participant.isActive ? ` ל- "פעיל"?` : ` ל- "לא פעיל"?`
                if (! await (handleConfirmation(title, content))) {
                    return
                }
                break;
        }

        dispatch(UpdateParticipantInfoAsync({ workoutId: Number(WorkoutId), participantUniqueId: updated_participant.uniqueId as string, updatedData: updated_participant })).unwrap()
            .then(() => dispatch(setEditFlag()))
            .catch((err) => console.error("Handled error:", err))
    }

    useEffect(() => {
        dispatch(GetSingleWorkoutSecuredAsync(WorkoutId as string)).unwrap()
            .catch((err) => {
                console.error("Handled error:", err);
            });
        // eslint-disable-next-line
    }, [editFlag])

    return (
        <>
            {currentWorkout?.participantsList === undefined ?
                <img src='/FadingCircles.gif' alt='spinner' style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
                :
                <div style={{ margin: 'auto', textAlign: 'center', marginTop: '5dvh' }}>
                    <h3>אימון {currentWorkout.type?.name} - {changeDateFormat(currentWorkout?.date as string)}, {currentWorkout?.time}.<br /> מדריך - {currentWorkout.instructor?.fullName === null ? "לא מוגדר" : currentWorkout.instructor?.fullName + ","} {currentWorkout.instructor?.phoneNumber === null ? "" : currentWorkout.instructor?.phoneNumber}<br />מיקום - {currentWorkout.location}<br />מחיר - {currentWorkout.price === 0 ? "ללא תשלום" : currentWorkout.price}</h3>
                    <Button variant="contained" size='small' color='info' onClick={() => createExcel(currentWorkout)}>ייצא לאקסל</Button>
                    <br /><br /><br />
                    <Button onClick={() => setSelectVisibility("active")} variant={SelectVisibility === "active" ? "contained" : "text"} color='inherit'>הצג מתאמנים פעילים בלבד</Button>
                    <Button onClick={() => setSelectVisibility("inactive")} variant={SelectVisibility === "inactive" ? "contained" : "text"} color='inherit'>הצג מתאמנים מבוטלים בלבד</Button>
                    <Button onClick={() => setSelectVisibility("all")} variant={SelectVisibility === "all" ? "contained" : "text"} color='inherit'>הצג את כל המתאמנים</Button>
                    <br /><br />
                    <Paper sx={tableDesign}>
                        <TableContainer sx={{ maxHeight: '50dvh' }}>
                            <Table stickyHeader aria-label="sticky table" sx={{ "& .MuiTableCell-root": { fontSize: "1em", textAlign: 'center' } }}>
                                <TableHead>
                                    <TableRow>
                                        {currentWorkout.price !== 0 && <TableCell>סטטוס תשלום</TableCell>}
                                        <TableCell>פעולות</TableCell>
                                        <TableCell>שם פרטי</TableCell>
                                        <TableCell>שם משפחה</TableCell>
                                        <TableCell>מספר טלפון</TableCell>
                                        {currentWorkout.fullForm &&
                                            <>
                                                <TableCell>מספר רשיון</TableCell>
                                                <TableCell>תוקף רשיון</TableCell>
                                                <TableCell>סוג אקדח</TableCell>
                                                <TableCell>מספר אקדח</TableCell>
                                            </>}
                                        <TableCell>קליבר</TableCell>
                                        <TableCell>הערות מתאמן</TableCell>
                                        <TableCell>הערות מנהל</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {currentWorkout?.participantsList?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).filter((value) => {
                                        if (SelectVisibility === "active")
                                            return value.isActive !== false
                                        else if (SelectVisibility === "inactive")
                                            return value.isActive === false
                                        return value
                                    })?.map((value, index) =>
                                        <TableRow key={index}>

                                            {currentWorkout.price !== 0 &&
                                                <TableCell>
                                                    <Checkbox size="small" checked={value.isPaid === undefined ? false : value.isPaid} onChange={() => handleUpdateParticipant({ ...value, "isPaid": !(value.isPaid as boolean) }, "isPaid")} />
                                                    {value.isPaid &&
                                                        <>
                                                            <br />
                                                            מספר עסקה - {value.paymentConfirmation}
                                                        </>
                                                    }
                                                </TableCell>
                                            }

                                            <TableCell>
                                                {value.isActive !== false ?
                                                    <Button variant="contained" size='small' color='error' onClick={() => handleUpdateParticipant({ ...value, "isActive": false }, "isActive")}> בטל מתאמן </Button>
                                                    :
                                                    <Button variant="contained" size='small' color='success' onClick={() => handleUpdateParticipant({ ...value, "isActive": true }, "isActive")}> החזר מתאמן </Button>
                                                }
                                            </TableCell>
                                            <TableCell>{value.firstName}</TableCell>
                                            <TableCell>{value.lastName}</TableCell>
                                            <TableCell>{value.phoneNum}</TableCell>
                                            {currentWorkout.fullForm &&
                                                <>
                                                    <TableCell>{value.licenseNumber}</TableCell>
                                                    <TableCell>{changeDateFormat(value.licenseExpiryDate)}</TableCell>
                                                    <TableCell>{value.pistolType}</TableCell>
                                                    <TableCell>{value.pistolNumber}</TableCell>
                                                </>}
                                            <TableCell>{value.caliber === "" ? "חסר" : value.caliber}</TableCell>
                                            <TableCell>{value.notes}</TableCell>
                                            <TableCell>
                                                <Link to={`/manageWorkout/participants/${WorkoutId}/${value.uniqueId}`} relative='path'
                                                    onClick={() => {
                                                        dispatch(setShowManagerNotesModal(true));
                                                    }}>
                                                    <span style={{ color: value.adminNotes === undefined ? "gray" : "green" }}>
                                                        {value.adminNotes === undefined || value.adminNotes?.length as number === 0 ? "אין הערות" : "קיימות הערות"}
                                                    </span>
                                                    <br />
                                                    <Button variant="text" size='small' color='secondary'>לחץ להזנה וצפייה</Button>
                                                </Link>
                                            </TableCell>
                                        </TableRow>)}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10, 15, 25]}
                            component="div"
                            count={currentWorkout?.participantsList?.length as number}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            sx={{ justifySelf: 'right', direction: 'ltr' }}
                        />
                    </Paper>
                </div>}
            <br /><br />
            <div style={{ fontSize: '20px', fontWeight: 'bold', display: 'flex', margin: 'auto', justifyContent: 'center' }}>
                <Button variant='contained' color='secondary' size='large'><Link to={`/manageWorkout/edit/${WorkoutId}`} style={{ color: 'white' }}>ערוך אימון זה</Link></Button>
                &emsp;
                <Button variant='contained' color='warning' size='large' ><Link to={'/manageWorkout'} style={{ color: 'white' }}>חזור לרשימת האימונים</Link></Button>
            </div>

            <Outlet />
        </>
    )
}

export default ManageWorkoutParticipants